var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-linkedin" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.linkedin.visibility")) + " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c(
            "div",
            { staticClass: "content-detail" },
            [
              _c("SelectComponent", {
                attrs: {
                  valueSelect:
                    _vm.draftInstance.form.networks.linkedin.visibility,
                  changeValueSelect: _vm.changeVisibilityPost,
                  data: {
                    PUBLIC: _vm.$t(
                      "dash.post-creator.form.linkedin.visibility-public"
                    ),
                    CONNECTIONS: _vm.$t(
                      "dash.post-creator.form.linkedin.visibility-connections"
                    ),
                    LOGGED_IN: _vm.$t(
                      "dash.post-creator.form.linkedin.visibility-members"
                    ),
                  },
                  positionAuto: false,
                  positionX: "left",
                },
              }),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _c("span", { staticClass: "label-beta" }, [
                    _vm._v(
                      "\n                     " +
                        _vm._s(
                          _vm.$t(
                            "dash.post-creator.form.linkedin.audience-targeting"
                          )
                        ) +
                        "\n                     "
                    ),
                    _c("span", { staticClass: "tag-beta" }, [_vm._v("Beta")]),
                  ]),
                  _c("ComponentSwitch", {
                    attrs: {
                      value: _vm.audienceTargeting,
                      onChange: (v) => (_vm.audienceTargeting = v),
                      id: "switch-settings-advanced-linkedin-3",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.linkedin.survey")) + " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c(
              "div",
              { staticClass: "type-switch" },
              [
                _vm._v(
                  "\n                 " +
                    _vm._s(
                      _vm.$t("dash.post-creator.form.linkedin.add-survey")
                    ) +
                    "\n                 "
                ),
                _c("ComponentSwitch", {
                  attrs: {
                    value:
                      _vm.draftInstance.form.networks.linkedin.survey.active,
                    onChange:
                      _vm.draftInstance.form.networks.linkedin.survey.setActive,
                    id: "switch-settings-advanced-linkedin-1",
                  },
                }),
              ],
              1
            ),
            _vm.draftInstance.form.networks.linkedin.survey.active
              ? _c(
                  "div",
                  { staticClass: "form-sondage" },
                  [
                    _c("SelectComponent", {
                      attrs: {
                        changeValueSelect: _vm.changeDurationSurvey,
                        data: {
                          oneDay: _vm.$t(
                            "dash.post-creator.form.linkedin.survey-duration-1day"
                          ),
                          threeDay: _vm.$t(
                            "dash.post-creator.form.linkedin.survey-duration-3days"
                          ),
                          oneWeek: _vm.$t(
                            "dash.post-creator.form.linkedin.survey-duration-1week"
                          ),
                          twoWeek: _vm.$t(
                            "dash.post-creator.form.linkedin.survey-duration-2weeks"
                          ),
                        },
                        valueSelect:
                          _vm.draftInstance.form.networks.linkedin.survey
                            .duration,
                        positionAuto: false,
                        positionX: "left",
                      },
                    }),
                    _c("div", { staticClass: "type-input" }, [
                      _c("i", { staticClass: "fa-regular fa-circle-question" }),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.draftInstance.form.networks.linkedin.survey
                                .question,
                            expression:
                              "draftInstance.form.networks.linkedin.survey.question",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "dash.post-creator.form.linkedin.survey-question"
                          ),
                          maxlength: "140",
                        },
                        domProps: {
                          value:
                            _vm.draftInstance.form.networks.linkedin.survey
                              .question,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.draftInstance.form.networks.linkedin.survey,
                              "question",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "list-question" }, [
                      _c("div", { staticClass: "type-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.draftInstance.form.networks.linkedin.survey
                                  .options[0],
                              expression:
                                "draftInstance.form.networks.linkedin.survey.options[0]",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t(
                              "dash.post-creator.form.linkedin.survey-option",
                              { n: 1 }
                            ),
                            maxlength: "30",
                          },
                          domProps: {
                            value:
                              _vm.draftInstance.form.networks.linkedin.survey
                                .options[0],
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.draftInstance.form.networks.linkedin.survey
                                  .options,
                                0,
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "type-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.draftInstance.form.networks.linkedin.survey
                                  .options[1],
                              expression:
                                "draftInstance.form.networks.linkedin.survey.options[1]",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t(
                              "dash.post-creator.form.linkedin.survey-option",
                              { n: 2 }
                            ),
                            maxlength: "30",
                          },
                          domProps: {
                            value:
                              _vm.draftInstance.form.networks.linkedin.survey
                                .options[1],
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.draftInstance.form.networks.linkedin.survey
                                  .options,
                                1,
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm.draftInstance.form.networks.linkedin.survey.options
                        .length >= 3
                        ? _c("div", { staticClass: "type-input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.draftInstance.form.networks.linkedin
                                      .survey.options[2],
                                  expression:
                                    "draftInstance.form.networks.linkedin.survey.options[2]",
                                },
                              ],
                              attrs: {
                                placeholder: _vm.$t(
                                  "dash.post-creator.form.linkedin.survey-option",
                                  { n: 3 }
                                ),
                                maxlength: "30",
                              },
                              domProps: {
                                value:
                                  _vm.draftInstance.form.networks.linkedin
                                    .survey.options[2],
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.draftInstance.form.networks.linkedin
                                      .survey.options,
                                    2,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass: "fa-regular fa-square-minus",
                              on: { click: () => _vm.removeOptionSurvey(2) },
                            }),
                          ])
                        : _vm._e(),
                      _vm.draftInstance.form.networks.linkedin.survey.options
                        .length == 4
                        ? _c("div", { staticClass: "type-input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.draftInstance.form.networks.linkedin
                                      .survey.options[3],
                                  expression:
                                    "draftInstance.form.networks.linkedin.survey.options[3]",
                                },
                              ],
                              attrs: {
                                placeholder: _vm.$t(
                                  "dash.post-creator.form.linkedin.survey-option",
                                  { n: 4 }
                                ),
                                maxlength: "30",
                              },
                              domProps: {
                                value:
                                  _vm.draftInstance.form.networks.linkedin
                                    .survey.options[3],
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.draftInstance.form.networks.linkedin
                                      .survey.options,
                                    3,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass: "fa-regular fa-square-minus",
                              on: { click: () => _vm.removeOptionSurvey(3) },
                            }),
                          ])
                        : _vm._e(),
                      _vm.draftInstance.form.networks.linkedin.survey.options
                        .length < 4
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-add",
                              on: { click: _vm.addOptionSurvey },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "dash.post-creator.form.linkedin.add-option"
                                    )
                                  )
                                ),
                              ]),
                              _c("i", { staticClass: "fa-solid fa-plus" }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        !_vm.draftInstance.form.networks.linkedin.survey.active &&
        _vm.draftInstance.form.urlsTextContentHistory.length
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  "\n             " +
                    _vm._s(
                      _vm.$t("dash.post-creator.form.linkedin.link-preview")
                    ) +
                    " \n             "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c(
                "div",
                { staticClass: "content-detail form-link" },
                [
                  _c(
                    "div",
                    { staticClass: "list-thubmmail" },
                    _vm._l(
                      _vm.draftInstance.form.urlsTextContentHistory,
                      function (url) {
                        return _c(
                          "div",
                          {
                            key: url,
                            staticClass: "thubmmail",
                            on: { click: () => _vm.selectUrl(url.value) },
                          },
                          [
                            _c("Checkbox", {
                              attrs: {
                                id: url,
                                prefixId: "thubmmail-",
                                isChecked:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.link == url.value,
                                isDisable:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.link == url.value,
                                add: () => _vm.selectUrl(url.value),
                                remove: () => {},
                              },
                            }),
                            _c("SnippetNetwork", {
                              attrs: {
                                link: url.value,
                                isDisable:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.link == url.value,
                                imageUrlDefault:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.customActived &&
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.image &&
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.image.id &&
                                  _vm.draftInstance.files.getById(
                                    _vm.draftInstance.form.networks.linkedin
                                      .snippet.image.id
                                  ).isUpload
                                    ? _vm.draftInstance.files.getById(
                                        _vm.draftInstance.form.networks.linkedin
                                          .snippet.image.id
                                      ).url
                                    : undefined,
                                titleDefault:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.customActived &&
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.title,
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                  _vm.draftInstance.form.urlsTextContentHistory.length
                    ? _c(
                        "div",
                        { staticClass: "type-switch" },
                        [
                          _vm._v(
                            "\n                 " +
                              _vm._s(
                                _vm.$t(
                                  "dash.post-creator.form.linkedin.link-preview-edit"
                                )
                              ) +
                              "\n                 "
                          ),
                          _c("ComponentSwitch", {
                            attrs: {
                              value:
                                _vm.draftInstance.form.networks.linkedin.snippet
                                  .customActived,
                              onChange: (v) => _vm.switchCustomSnippetChange(v),
                              id: "switch-settings-advanced-linkedin-2",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.draftInstance.form.networks.linkedin.snippet
                    .customActived &&
                  _vm.draftInstance.form.urlsTextContentHistory.length
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''",
                            },
                          ],
                          ref: "inputImageSnippet",
                          attrs: {
                            name: "file",
                            type: "file",
                            id: "file",
                            multiple: false,
                            accept: `image/*`,
                            hidden: "",
                          },
                          on: {
                            change: _vm.selectImageSnippet,
                            click: () => {},
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "type-btn-add",
                            on: { click: _vm.toggleAddImage },
                          },
                          [
                            _c("i", { staticClass: "fa-solid fa-image" }),
                            _vm.draftInstance.form.networks.linkedin.snippet
                              .image &&
                            _vm.draftInstance.form.networks.linkedin.snippet
                              .title.id &&
                            _vm.draftInstance.files.getById(
                              _vm.draftInstance.form.networks.linkedin.snippet
                                .image.id
                            ) &&
                            _vm.draftInstance.files.getById(
                              _vm.draftInstance.form.networks.linkedin.snippet
                                .image.id
                            ).isUploading
                              ? [
                                  _vm._v(
                                    "\n                         " +
                                      _vm._s(
                                        _vm.$t(
                                          "dash.post-creator.form.linkedin.media-uploading"
                                        )
                                      ) +
                                      "\n                     "
                                  ),
                                ]
                              : _vm.draftInstance.form.networks.linkedin.snippet
                                  .image &&
                                _vm.draftInstance.form.networks.linkedin.snippet
                                  .image.id &&
                                _vm.draftInstance.files.getById(
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.image.id
                                ) &&
                                _vm.draftInstance.files.getById(
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.image.id
                                ).isUpload
                              ? [
                                  _vm._v(
                                    "\n                         " +
                                      _vm._s(
                                        _vm.draftInstance.files.getById(
                                          _vm.draftInstance.form.networks
                                            .linkedin.snippet.image.id
                                        ).info.name
                                      ) +
                                      "\n                          "
                                  ),
                                  _c("i", {
                                    staticClass: "fa-regular fa-square-minus",
                                  }),
                                ]
                              : [
                                  _vm._v(
                                    "\n                         " +
                                      _vm._s(
                                        _vm.$t(
                                          "dash.post-creator.form.linkedin.add-image"
                                        )
                                      ) +
                                      "\n                         "
                                  ),
                                  _c("i", { staticClass: "fa-solid fa-plus" }),
                                ],
                          ],
                          2
                        ),
                        _c("div", { staticClass: "type-input" }, [
                          _c("i", { staticClass: "fa-solid fa-pen-to-square" }),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet.title,
                                expression:
                                  "draftInstance.form.networks.linkedin.snippet.title",
                              },
                            ],
                            attrs: { placeholder: "Titre par default" },
                            domProps: {
                              value:
                                _vm.draftInstance.form.networks.linkedin.snippet
                                  .title,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.draftInstance.form.networks.linkedin
                                    .snippet,
                                  "title",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm.draftInstance.form.networks.linkedin.snippet.title
                            ? _c("i", {
                                staticClass: "fa-regular fa-square-minus",
                                on: {
                                  click: () =>
                                    (_vm.draftInstance.form.networks.linkedin.snippet.title =
                                      ""),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }